import Course33MediaSection from './section';

/** Admin section for per-day Morning/Night audio (days 1–21). */
const Course33DayMedia = () => <Course33MediaSection mode="dayMedia" />;

export default Course33DayMedia;
